import { LOAD_CARD_CREATE_CONFIG_SUCCESS, SET_APP_DATA } from '../../../actions/app/index.tsx';
import type { Action } from '../../../actions/index.tsx';
import {
	SET_INLINE_CREATE_SESSION_ID,
	CLEAR_INLINE_CREATE_SESSION_ID,
} from '../../../actions/inline-create/index.tsx';
import type { InlineCreateState } from './types.tsx';

const defaultState: InlineCreateState = {
	sessionId: undefined,
	cardTypeIds: [],
};

const projectReducer = (
	state: InlineCreateState = defaultState,
	action: Action,
): InlineCreateState => {
	switch (action.type) {
		case SET_APP_DATA:
			if (!action.payload.entities.inlineCreate?.cardTypeIds) {
				return state;
			}
			return { ...state, cardTypeIds: action.payload.entities.inlineCreate.cardTypeIds };

		case SET_INLINE_CREATE_SESSION_ID:
			return { ...state, sessionId: action.payload.sessionId };

		case CLEAR_INLINE_CREATE_SESSION_ID:
			return { ...state, sessionId: undefined };

		case LOAD_CARD_CREATE_CONFIG_SUCCESS:
			return { ...state, cardTypeIds: action.payload.cardTypes.map((t) => t.id) };

		default:
			return state;
	}
};

export default projectReducer;
